module.exports = __webpack_public_path__ + "img/10.d7a1560b.jpg";